import React from 'react';
import ReactIfElse from '@jswork/react-if-else';
import RCM from '@jswork/react-condition-manager';
import RSM from '@jswork/react-status-manager';
import ReactList from '@jswork/react-list';
import ReactAntSelect from '@jswork/react-ant-select';
import ReactAntTree from '@jswork/react-ant-tree';
import ReactAntTreeSelect from '@jswork/react-ant-tree-select';
import ReactAntRadioGroup from '@jswork/react-ant-radio-group';
import ReactAntTable from '@jswork/react-ant-table';
import ReactAntCheckbox from '@jswork/react-ant-checkbox';
import ReactAntCheckboxGroup from '@jswork/react-ant-checkbox-group';
import ReactAntInputSearch from '@jswork/react-ant-input-search';
import AntdFormBuilder from 'antd-form-builder';
import RctplAntSelectDefault from '@jswork/rctpl-ant-select-default';
import ReactEmptyState from '@jswork/react-empty-state';
import EmptyImage from 'common/components/EmptyImage';
import useActiveState from '@jswork/use-active-state';
import { useForceUpdate } from 'mobx-react-lite';

Object.assign(ReactAntSelect.defaultProps, { template: RctplAntSelectDefault });
Object.assign(ReactEmptyState.defaultProps, { element: React.createElement(EmptyImage) });

// inject react layout services:
nx.$rc = {
  // debug: process.env.NODE_ENV === 'development',
  debug: false,
  rcm: RCM,
  rsm: RSM,
  ife: ReactIfElse,
  list: ReactList,

  // form control
  select: ReactAntSelect,
  table: ReactAntTable,
  tree: ReactAntTree,
  treeSelect: ReactAntTreeSelect,
  radioGroup: ReactAntRadioGroup,
  inputSearch: ReactAntInputSearch,
  checkbox: ReactAntCheckbox,
  checkboxGroup: ReactAntCheckboxGroup,
  empty: ReactEmptyState,
  fb: AntdFormBuilder,
};

nx.$hooks = {
  useActiveState,
  useForceUpdate,
};
